export default function* take(iterable, count) {
    for (const item of iterable) {
        if (count == 0) {
            break;
        }
        yield item;
        count--;
    }
}
